import * as Business               from '../business';
import * as MessagesQueueSelectors from '../messages_queue/selectors';
import * as User                   from '../user';
import { getResources }            from 'redux-resource';
import { getResourceStatuses }     from '../util/get_resource_statuses';
import { getStatus }               from 'redux-resource';
import { isAfter }                 from 'date-fns';
import { subDays }                 from 'date-fns';


export function getContacts(state, businessID) {
  const customers = getResources(state.customers, businessID);
  const team      = Business.getTeam(state, businessID);

  if (team)
    return customers.map(addNamesToUsers);
  else
    return customers;

  function addNamesToUsers(customer) {
    const assignees    = customer?.conversation?.assignees ?? [];
    const participants = customer?.conversation?.participants ?? [];

    return {
      ...customer,
      conversation: {
        ...customer.conversation,
        participants: addUserNames(participants),
        assignees:    addUserNames(assignees)
      }
    };

    function addUserNames(list) {
      return list.map(item => {
        return {
          ...item,
          user: {
            id:   item.user.id,
            name: getUserName(item.user.id)
          }
        };
      });
    }

    function getUserName(userID) {
      const teamUser = team.users.find(u => u.id === userID);
      return teamUser?.name;
    }
  }
}

export function getEmailContacts(state, businessID) {
  const contacts          = getContacts(state, businessID);
  const contactsWithEmail = contacts.filter(customer => hasEmail(customer));
  return contactsWithEmail;
}

function hasEmail(customer) {
  return customer.contact?.email?.address;
}


function getContactsReadStatus(state, businessID) {
  return getStatus(state.customers, `requests.read-${businessID}.status`);
}


function getContactsReadStatusCode(state, businessID) {
  return state.customers.requests[`read-${businessID}`] ?
    state.customers.requests[`read-${businessID}`].statusCode :
    null;
}


export function getContactsStatuses(state, businessID) {
  return {
    createStatus:   {},
    deleteStatus:   {},
    readStatus:     getContactsReadStatus(state, businessID),
    readStatusCode: getContactsReadStatusCode(state, businessID),
    updateStatus:   {}
  };
}

export function getContact(state, customerID) {
  return getResources(state.customers, [ customerID ])[0];
}

export function getContactReadStatus(state, customerID) {
  return getStatus(state.customers, `meta[${customerID}].readStatus`);
}

export function getContactsCreateStatus(state, businessID) {
  return getStatus(state.customers, `requests.create-${businessID}.status`);
}

export function getContactUpdateStatus(state, customerID) {
  return getStatus(state.customers, `meta[${customerID}].updateStatus`);
}

export function getActivities(state, customerID) {
  const customer = getResources(state.customers, [ customerID ])[0];
  return customer && customer.activities;
}

export function getActivitiesWithPendingQueue(state, customerID) {
  const activities = getActivities(state, customerID);
  if (activities) {
    const messagesInQueue   = MessagesQueueSelectors.getContactMessagesQueue(state, customerID);
    const userName          = User.getUserName(state);
    const activitiesInQueue = mapMessagesInQueueToActivities(messagesInQueue, userName);
    return activities.concat(activitiesInQueue).sort(byTimestamp);
  } else
    return null;
}

export function getRecentContacts(state, businessID) {
  const customers = getContacts(state, businessID);
  const sorted    = customers.sort(byMostRecentlyActive);

  return sorted;
}


export function getFollowingContacts(state, businessID, currentUserID) {
  const customers = getContacts(state, businessID);
  const sorted    = customers
    .filter(isAssignedToCurrentUser)
    .sort(byMostRecentlyActive);

  return sorted;

  function isAssignedToCurrentUser(customer) {
    const participants = customer?.conversation?.participants ?? [];
    return participants.some(participant => participant.user.id === currentUserID);
  }
}


export function getContactStatuses(state, customerID) {
  return getResourceStatuses(state.customers, customerID);
}

export function getLeadsAddedDaysAgo(state, businessID, daysAgo) {
  const customers = getContacts(state, businessID);
  const now       = new Date();
  const dateAgo   = subDays(now, daysAgo);
  return customers
    .filter(customer => customer.lead)
    .filter(customer => isAfter(new Date(customer.createdAt), dateAgo));
}

function byMostRecentlyActive(a, b) {
  if (a.lastActive < b.lastActive)
    return 1;
  else if (a.lastActive > b.lastActive)
    return -1;
  else
    return 0;
}

function byTimestamp(a, b) {
  const timestampA = new Date(a.timestamp).getTime();
  const timestampB = new Date(b.timestamp).getTime();
  return timestampA - timestampB;
}

function mapMessagesInQueueToActivities(messagesInQueue = [], userName) {
  return messagesInQueue.map(message => {
    return {
      type:      'OutgoingMessage',
      timestamp: message.timestamp,
      message:   {
        attachments: message.attachments,
        body:        message.body,
        id:          message.id,
        progress:    message.progress,
        status:      message.status,
        user:        {
          name: userName
        }
      }
    };
  });
}
